import React from 'react';
import MyPortfolio from '../MyPortfolio/MyPortfolio';

const MyProfile = () => {
    return (
        <div>
            <MyPortfolio></MyPortfolio>
        </div>
    );
};

export default MyProfile;